!function() {
  function e(e, t, o, r) {
    Object.defineProperty(e, t, {
      get: o,
      set: r,
      enumerable: !0,
      configurable: !0
    });
  }
  var t = ("undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}).parcelRequire5f74, o = t.register;
  o("3tDrm", function(o, r) {
    e(o.exports, "initBodyUtils", function() {
      return c;
    });
    var n = t("gjV2B"), i = t("8NSEU");
    function c() {
      const e = e => {
        if ("Enter" === e.key || " " === e.key) {
          e.preventDefault();
          const t = e.target;
          t.classList.add("active"), setTimeout(() => {
            t.classList.remove("active");
          }, 150), t.click();
        }
      }, t = () => {
        document.documentElement.style.setProperty("--visual-viewport", `${window.visualViewport?.height || window.innerHeight}px`);
      }, o = () => {
        window._buttonRoleObserver && (window._buttonRoleObserver.disconnect(), delete window._buttonRoleObserver);
      };
      (() => {
        new (0, i.LockerManager), (() => {
          const e = (0, n.debounce)(e => {
            "Escape" === e.key && (document.querySelectorAll("details").forEach(e => !e.open), 
            document.querySelectorAll("[data-locker]").forEach(e => {
              e.checked && e.click();
            }), document.body.classList.remove("overflow-clip"));
          });
          document.addEventListener("keydown", e, {
            passive: !0
          });
        })(), document.addEventListener("keydown", e => {
          const t = document.activeElement;
          if (("Enter" === e.key || "Space" === e.code) && "LABEL" === t.tagName && t.htmlFor) {
            const o = document.getElementById(t.htmlFor);
            !o || "checkbox" !== o.type && "radio" !== o.type || (t.click(), o.click(), e.preventDefault());
          }
        }), (() => {
          const e = e => {
            e.htmlFor && !e.hasAttribute("tabindex") && (e.tabIndex = 0);
          };
          document.querySelectorAll("label[for]").forEach(e), new MutationObserver(t => {
            t.forEach(t => {
              t.addedNodes.forEach(t => {
                t.nodeType === Node.ELEMENT_NODE && ("LABEL" === t.tagName && t.htmlFor && e(t), 
                (t.querySelectorAll ? t.querySelectorAll("label[for]") : []).forEach(e));
              });
            });
          }).observe(document.body, {
            childList: !0,
            subtree: !0
          });
        })(), (() => {
          const t = t => {
            t.hasAttribute("tabindex") || (t.tabIndex = 0), t.hasAttribute("data-keyboard-enabled") || (t.addEventListener("keydown", e), 
            t.setAttribute("data-keyboard-enabled", "true"));
          };
          document.querySelectorAll('[role="button"]').forEach(t);
          const o = new MutationObserver(e => {
            e.forEach(e => {
              e.addedNodes.forEach(e => {
                e.nodeType === Node.ELEMENT_NODE && ("button" === e.getAttribute("role") && t(e), 
                (e.querySelectorAll ? e.querySelectorAll('[role="button"]') : []).forEach(t));
              });
            });
          });
          o.observe(document.body, {
            childList: !0,
            subtree: !0
          }), window._buttonRoleObserver = o;
        })(), (() => {
          const e = e => {
            e.addEventListener("change", () => {
              e.checked ? document.body.classList.add("overflow-clip") : document.body.classList.remove("overflow-clip");
            });
          };
          document.querySelectorAll("[data-locker]").forEach(e), window.addEventListener("locker_add", t => {
            const o = t.detail;
            if (o) {
              const t = document.querySelector(`#${o}`);
              t && e(t);
            }
          });
        })(), (() => {
          const e = document.querySelector("[data-scroll-trigger]");
          e && new IntersectionObserver(e => {
            e[0].isIntersecting ? document.body.classList.remove("is-scrolled") : document.body.classList.add("is-scrolled"), 
            window.dispatchEvent(new CustomEvent("scroll-trigger", {
              bubbles: !0,
              detail: {
                isScrolled: !e[0].isIntersecting
              }
            }));
          }).observe(e);
        })(), (() => {
          const e = "recentlyViewed", t = JSON.parse(localStorage.getItem(e)) || [], o = location.href.match(/\/products\/([^\?#]+)/), r = o?.[1];
          if (r && !t.includes(r)) {
            const o = [ r, ...t ].slice(0, 8);
            localStorage.setItem(e, JSON.stringify(o)), window.Shopify = {
              ...window.Shopify,
              recentlyViewed: o
            };
          }
        })(), window.Geo && (() => {
          const e = localStorage.getItem("GEO_POPUP_SHOWN");
          if (e) {
            const {timestamp: t} = JSON.parse(e), o = 18e5;
            if (Date.now() - t < o) return;
          }
          window.Geo.perform(e => {
            if (e.handle !== window.Shopify?.country) {
              const t = document.getElementById("Modal-Localization")?.closest(".modal"), o = document.getElementById("Modal-Localization"), r = t.querySelector('[name="country_code"]');
              if (!r || !t) return;
              r.value = e.handle, r.dispatchEvent(new Event("change", {
                bubbles: !0
              })), o.checked || o.click(), document.body.classList.add("attentive-hide"), localStorage.setItem("GEO_POPUP_SHOWN", JSON.stringify({
                timestamp: Date.now()
              }));
            }
          });
        })(), t(), window.MBF.updateVisualViewport = t, (() => {
          const e = window.location.href;
          if (e.includes("form_type=customer")) {
            const t = e.split("#").pop() || "footer", o = document.querySelector(`#${t}`) || document.querySelector('footer[action^="/contact"]');
            if (o) {
              const e = o.querySelector('[type="email"]');
              if (e && e.value.length > 0) {
                const e = document.createElement("p");
                e.classList.add("mt-sm", "text-red"), e.innerText = window.strings?.newsletter?.existing || "You are already subscribed.", 
                o.appendChild(e), window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                  event: "newsletter_signup",
                  form_action: "submit-failure",
                  error_id: window.strings?.newsletter?.existing
                });
              }
            }
          }
        })();
        (() => {
          const e = window.matchMedia("(max-width: 1024px)");
          t(), e.addEventListener("change", () => {
            t();
          });
        })(), window._accessibilityCleanup = o;
      })();
    }
  }), o("gjV2B", function(t, o) {
    e(t.exports, "debounce", function() {
      return r;
    });
    const r = (e, t) => {
      let o;
      const r = (...r) => {
        clearTimeout(o), o = setTimeout(() => {
          clearTimeout(o), e(...r);
        }, t);
      };
      return r.cancel = () => {
        clearTimeout(o), o = null;
      }, r;
    };
  }), o("8NSEU", function(t, o) {
    e(t.exports, "LockerManager", function() {
      return r;
    });
    class r {
      #e=new Set;
      #t=new Map;
      #o=null;
      constructor(e = "main", t = ".shopify-section", o = ".ajax-modal", r = "header") {
        this.selectors = {
          mainSelector: e,
          sectionSelector: t,
          modalSelector: o,
          headerSelector: r
        }, this.#o = window.matchMedia("(min-width: 1024px)"), this.init();
      }
      init() {
        this.updateElementsCache(), this.initializeExistingLockers(), this.setupEventListeners(), 
        this.setupMediaQueryListener();
      }
      updateElementsCache() {
        const {mainSelector: e, sectionSelector: t, modalSelector: o, headerSelector: r} = this.selectors;
        try {
          const n = document.querySelector(e), i = Array.from(document.querySelectorAll(t)), c = Array.from(document.querySelectorAll(o)), s = Array.from(document.querySelectorAll(r));
          if (!n) return void console.warn(`LockerManager: Main element "${e}" not found.`);
          this.#e.clear(), [ ...i, ...c, ...s, n ].filter(Boolean).forEach(e => this.#e.add(e));
        } catch (e) {
          console.error("LockerManager: Error updating elements cache:", e);
        }
      }
      isHeaderElement(e) {
        const {headerSelector: t} = this.selectors;
        return e.matches && (e.matches(t) || e.closest(t));
      }
      shouldMakeHeaderInert() {
        return this.#o.matches;
      }
      getFilteredElements(e, t) {
        const {sectionSelector: o} = this.selectors, r = t.contains(e), n = this.shouldMakeHeaderInert();
        let i = Array.from(this.#e).filter(o => this.isHeaderElement(o) ? n : r ? o !== t && !o.contains(e) : o === t || !t.contains(o) && !o.contains(e));
        const c = e.closest(o);
        if (c) {
          const t = Array.from(c.children).filter(t => t !== e && (!this.isHeaderElement(t) || n) && !t.contains(e) && "SCRIPT" !== t.tagName && "STYLE" !== t.tagName), o = new Set([ ...i, ...t ]);
          i = Array.from(o);
        }
        return i;
      }
      #r(e, t, o) {
        const r = document.querySelector(this.selectors.mainSelector);
        if (!r) return;
        let n = this.#t.get(e);
        const i = this.getFilteredElements(t, r);
        if (t.toggleAttribute("inert", !o), o) {
          if (n) n.isActive = !0; else {
            const t = Array.from(document.querySelectorAll("[inert]"));
            n = {
              preExistingInertElements: t,
              isActive: !0
            }, this.#t.set(e, n);
          }
          i.forEach(e => {
            e.setAttribute("inert", "");
          });
        } else n && (n.isActive = !1, i.forEach(e => {
          n.preExistingInertElements.includes(e) || e.removeAttribute("inert");
        }));
      }
      #n(e, t) {
        e && (t ? e.hasAttribute("inert") && (e.removeAttribute("inert"), e.dataset.inertRemoved = "true") : e.dataset.inertRemoved && (e.setAttribute("inert", ""), 
        delete e.dataset.inertRemoved));
      }
      #i() {
        for (const [e, t] of this.#t.entries()) if (t.isActive) {
          const t = document.querySelector(`[data-locker-container="${e.id}"]`);
          t && this.#r(e, t, !0);
        }
      }
      #c(e, t = !1) {
        if (!e?.id) return void console.warn("LockerManager: Attempted to initialize locker without an ID.");
        const o = document.querySelector(`[data-locker-container="${e.id}"]`);
        if (o) {
          if (t) {
            const t = Array.from(this.#t.entries()).find(([t]) => t.id === e.id);
            if (t) {
              const [o, r] = t;
              this.#t.delete(o), this.#t.set(e, r), e.checked = r.isActive;
            }
          }
          this.#r(e, o, e.checked), e.addEventListener("change", t => {
            const r = t.target.checked, n = t.target.closest(this.selectors.sectionSelector);
            this.#n(n, r), this.#r(e, o, r);
          });
        } else console.warn(`LockerManager: No container found for locker: ${e.id}`);
      }
      initializeExistingLockers() {
        document.querySelectorAll("[data-locker]").forEach(e => this.#c(e));
      }
      setupMediaQueryListener() {
        this.#o.addEventListener("change", () => {
          this.#i();
        });
      }
      setupEventListeners() {
        window.addEventListener("locker_add", e => {
          this.updateElementsCache();
          const t = e.detail;
          if (!t) return void console.warn('LockerManager: "locker_add" event triggered without locker ID in detail.');
          const o = document.querySelector(`#${t}`);
          o ? this.#c(o, !0) : console.warn(`LockerManager: Could not find new locker with ID: ${t}`);
        });
      }
      destroy() {
        this.#o && this.#o.removeEventListener("change", this.#i), this.#e.clear(), this.#t.clear();
      }
    }
  });
}();